<template>
  <div class="copywritingm">
    <div class="copywritingmbox" v-if="status">
      <div class="header">
        <img src="@/assets/mobile/back.png" alt="" @click="back()" />
        <p @click="selecttc = !selecttc">{{ listdata.template.title }}</p>
        <span @click="jumprouter('/history')">创作历史</span>
      </div>
      <div class="list" v-show="selecttc">
        <div class="listbox">
          <div class="swiper">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide :class="swiperIndex == -1 ? 'swiperOn' : ''"
                ><span data-id="0" :data-index="-1">全部</span></swiper-slide
              >
              <swiper-slide
                :class="swiperIndex == index ? 'swiperOn' : ''"
                v-for="(item, index) in itemtype"
                :key="index"
                ><span :data-index="index" :data-id="item.id">{{
                  item.title
                }}</span></swiper-slide
              >
            </swiper>
          </div>
          <el-scrollbar>
            <ul>
              <li
                v-for="(item, index) in list"
                :key="index"
                @click.stop="jumppage(item.type, item.id)"
              >
                <div class="icon"><img :src="item.image" alt="" /></div>
                <p :class="item.id == listdata.id ? 'on' : ''">
                  {{ item.title }}
                </p>
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </div>

      <div class="formbox">
        <el-scrollbar>
          <div class="form" v-for="(item, index) in listdata.list" :key="index">
            <div v-if="item.type == 'input'">
              <p :class="item.value != '' ? 'this' : ''">{{ item.title }}</p>
              <el-input
                v-model="item.value"
                :maxlength="item.max"
                :placeholder="item.tip"
                show-word-limit
              ></el-input>
            </div>
            <div v-if="item.type == 'textarea'">
              <p :class="item.value != '' ? 'this' : ''">{{ item.title }}</p>
              <el-input
                v-model="item.value"
                style="height: 200px"
                type="textarea"
                :maxlength="item.max"
                :placeholder="item.tip"
                show-word-limit
              ></el-input>
            </div>
            <div v-if="item.type == 'list'">
              <p class="this">{{ item.title }}</p>
              <ul>
                <li
                  :class="list == item.value ? 'on' : ''"
                  v-for="(list, i) in item.option"
                  :key="i"
                >
                  {{ list }}
                </li>
              </ul>
            </div>
            <div v-if="item.type == 'option'">
              <p :class="item.value != '' ? 'this' : ''">{{ item.title }}</p>
              <el-select
                v-model="item.value"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="list in item.option"
                  :key="list"
                  :label="list"
                  :value="list"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <p class="tip">
        <span></span>
        不知道写啥？试试插入示例
      </p>
      <div class="create-btn-cell" @click="generateNow()">
        <p>立即生成</p>
      </div>
    </div>
    <div class="resultbox" v-else>
      <div class="header">
        <img src="@/assets/mobile/back.png" alt="" @click="back()" />
		<p>创作结果</p>
        <!-- <p @click="status = true"><span>点击返回创作页面</span></p> -->
        <!-- <span @click="jumprouter('/history')">创作历史</span> -->
      </div>
      <div style="width: 100%; ">
		  <el-input style="padding: 15px;" id="textarea_id" v-model="content" type="textarea" rows="15"></el-input>
        <!-- <div class="header-wrap">
          <div class="title">
            <i class="el-icon-success"></i>
            <span>作品已生成，快去分享吧</span>
          </div>
          <div class="text-gray">作品有效期1天，分享到朋友圈集赞送会员哦</div>
        </div> -->
       <!-- <div class="videobox">
          <div ref="contentBox" class="contentbox">
            {{ content }}
            <div v-if="loading" class="content loading">
              <div class="content1">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            </div>
          </div>
        </div> -->
		<div v-if="listdata.template.video_template.id > 0" class="mode">
		    <div class="imgbox">
		        <img :src="listdata.template.video_template.show_image" alt="">
		        <p @click="drawer=true">更换模板</p>
		    </div>
		   <!-- <p class="tip">你已选择普通模板，视频中的数字人暂不支持对口型说话，推荐你使用自定义模板。 <span>前往使用</span></p> -->
		    <p class="tip">点击更换模板可选择你想要的模板，快速生成文生视频</p>
		</div>
        <div class="btn-wrap">
          <div class="share-btn-wrap flex-center">
            <!-- <div @click="moreTemplate" class="btn-share flex-center">
              <span>更多模板</span>
            </div> -->
            <div @click="createVideo" style="cursor: pointer" class="btn-down">
              <span>立即生成</span>
            </div>
          </div>
          <!-- <div class="tips">
            推荐使用「<a
              href="https://www.animiz.cn/videoclipmaster/?wancaiai"
              target="_blank"
              >康桥特效大师</a
            >」，一键去除视频背景
          </div> -->
        </div>
      </div>
      <!-- <ul>
        <li v-for="(item, index) in task1" :key="index">
          <div class="listbox">
            <div class="title">
              <p>{{ item.title }} | {{ item.problem }}</p>
              <p class="status">已生成</p>
            </div>
            <div class="contenbox">
              <div class="content">{{ item.content }}</div>
              <div class="button">
                <p>删除</p>
                <p>复制</p>
              </div>
            </div>
          </div>
          <p class="createtime">{{ item.createtime }}</p>
        </li>
      </ul> -->
      <!-- <ul>
        <li v-for="(item, index) in task2" :key="index">
          <div class="listbox">
            <div class="title">
              <p>{{ item.title }} | {{ item.problem }}</p>
              <p class="status">已生成</p>
            </div>
            <div class="contenbox">
              <div class="content">{{ item.content }}</div>
              <div class="button">
                <p>删除</p>
                <p>复制</p>
              </div>
            </div>
          </div>
          <p class="createtime">{{ item.createtime }}</p>
        </li>
      </ul> -->
    </div>
	<el-drawer
	  size="80%"
	  direction="btt"
	  :visible.sync="drawer"
	  title="选择视频模板"
	  :show-close="true"
	>
	    <div class="content-wrap">
	        <div class="content-box">
	            <div class="content-divider"></div>
	            <div class="right">
	                <el-scrollbar>
	                    <ul>
	                        <li v-for="(item,index) in template_list" :key="index" >
	                            <img :src="item.show_image" alt="" class="show_image" @click="selectTemplate(item.id, item.show_image)">
	                            <div class="title">{{item.title}}</div>
	                        </li>
	                    </ul>
						<el-pagination
						style="margin-top: 20px;margin-bottom: 20px;text-align: center;"
						  background
						  :page-size="12"
						  @size-change="handleSizeChange"
						  @current-change="handleCurrentChange"
						  :current-page="page"
						  layout="prev, next"
						  :total="total">
						</el-pagination>
	                </el-scrollbar>
	            </div>
	        </div>
	    </div>
	</el-drawer>
  </div>
</template>

<script>
import chatshowbox from "@/components/chatshowbox";
import login from "@/components/login";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { indexFields, articleGetHistory } from "@/api/copywriting";
import { getIndexData } from "@/api/index";
import Clipboard from "clipboard";
import {videoGetListV2} from "@/api/video"
import { Message } from 'element-ui'
import {createVideo,updateContent} from '@/api/article'
export default {
  data() {
    return {
	  drawer:false,
      loading: false,
      status: true,
      params: {
        cid: 0,
        keyword: "",
      },
      pageId: 0,
	  page:1,
	  total:0,
      selecttc: false,
      swiperIndex: -1,
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 8,
        on: {
          click: (e) => {
            this.swiperClick(e);
          },
        },
      },
      itemtype: [],
      listdata: {
        template: {
          title: "",
		  video_template:{
			  id:0,
			  show_image:'',
		  }
        },
      },
      list: [],
      task1: [],
      task2: [],
      currentType: 1,
      content: "",
	  aid:0,
	  template_list:[],
    };
  },
  mounted() {
    this.pageId = this.$route.params.id;
    indexFields({ tid: this.pageId }).then((res) => {
      this.listdata = res.data;
	  if(this.listdata.template.video_template == null) {
		  this.listdata.template.video_template = {
			  id:0,
			  show_image:'',
		  }
	  }
    });
    this.articleGetHistory();
    this.getIndexData();
	this.videoGetListV2();
  },
  methods: {
	  handleSizeChange(val) {
	      this.page = 1
	      this.videoGetListV2()
	  },
	  handleCurrentChange(val) {
	      this.page = val
	      this.videoGetListV2()
	  },
	  moreTemplate() {
		if(this.aid <= 0) {
			Message({
				message: '请先生成文案内容',
				type: 'error',
				duration: 3 * 1000
			})
			return;
		}
		updateContent({aid:this.aid, content:this.content}).then(res=>{
			this.$router.push({ path: '/microvideo?aid=' + this.aid});
		})  
	  },
	  selectTemplate(id, show_image) {
		  this.listdata.template.video_template.id = id;
		  this.listdata.template.video_template.show_image = show_image;
		  this.drawer = false;
	  },
	  videoGetListV2() {
		  videoGetListV2({page:this.page}).then((res) => {
			 this.template_list = res.data.data;
			 this.total = res.data.total;
		  })
	  },
	createVideo() {
		this.content = this.content.trim();
		if(this.listdata.template.video_template.id <= 0) {
			if(this.aid <= 0) {
				Message({
					message: '请先生成文案内容',
					type: 'error',
					duration: 3 * 1000
				})
				return;
			}
			this.$router.push({ path: '/microvideo?aid=' + this.aid});
			return;
		}
		if(this.content == '') {
			Message({
				message: '请先生成文案内容',
				type: 'error',
				duration: 3 * 1000
			})
			return;
		}
		const loading1 = this.$loading({
			lock: true,
			text: '任务提交中....',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		let params = {
			creation_id:this.pageId,
			aid:this.aid,
			template_id:this.listdata.template.video_template.id,
			content:this.content
		};
		createVideo(params).then(res=>{
			loading1.close()
			if(res.code == 0) {
				// 成功
				Message({
					message: res.message,
					type: 'success',
					duration: 3 * 1000
				})
				this.$router.push({ path: '/history/1'});
			}else {
				Message({
					message: res.message,
					type: 'error',
					duration: 3 * 1000
				})
			}
		})
	},
    getIndexData() {
      var that = this;
      getIndexData(this.params).then((response) => {
        // console.log(response)
        that.itemtype = response.data.category;
        that.list = response.data.template;
        that.list.forEach((item) => {
          if (item.id == that.pageId) {
            that.currentType = item.type;
          }
        });
      });
    },
    articleGetHistory() {
      articleGetHistory().then((res) => {
        this.task1 = res.data.result;
        this.task2 = res.data.history;
      });
    },
    copy(event, content) {
      const clipboard = new Clipboard(event.target, {
        text: () => content,
      });
      clipboard.on("success", () => {
        clipboard.destroy();
        this.$message({
          message: "复制成功",
          type: "success",
          duration: 3 * 1000,
        });
      });
      clipboard.on("error", () => {
        clipboard.destroy();
        this.$message({
          message: "复制失败",
          type: "error",
          duration: 3 * 1000,
        });
      });
      clipboard.onClick(event);
    },
    jumprouter(router) {
      this.$router.push({ path: router });
    },
    back() {
      this.$router.back();
    },
    swiperClick(e) {
      // this.params.cid = e.target.getAttribute("data-id");
      this.swiperIndex = e.target.getAttribute("data-index");
      this.getIndexData();
    },
    jumppage(type, id, router) {
      this.selecttc = false;
      if (type == 2) {
        this.$router.push({ path: "/copywriting/" + id });
        location.reload();
      } else if (id == 1) {
        this.$router.push({ path: "/microvideo" });
      } else if (id == 2) {
        this.$router.push({ path: "/customized" });
      } else if (id == 3) {
        this.$router.push({ path: "/face" });
      } else if (id == 4) {
        this.$router.push({ path: "/clone" });
      }
    },
    generateNow() {
      if (!localStorage.getItem("gpt-token")) {
        this.loginbox = true;
        return false;
      }
      try {
        this.listdata.list.forEach((item, index) => {
          if (!item.value) {
            throw Error(item.title);
          }
        });
      } catch (e) {
        this.$message.error(e + "不能为空");
        return false;
      }
      this.status = false;
      console.log(this.listdata);
      this.startContent(
        this.listdata.template.chat_url,
        JSON.stringify(this.listdata)
      );
    },
	rollingBottom () {
		let textarea = document.getElementById('textarea_id');
		textarea.scrollTop = textarea.scrollHeight;
	},
    startContent(url, params) {
      let arr = JSON.parse(params);
      let data = {
        title: arr.template.title,
        id: arr.template.id,
        fields: arr.list,
      };
      this.content = "";
      let that = this;
      let headers = {
        token: localStorage.getItem("gpt-token"),
      };
      // return false;
      let eventSourcepost = fetchEventSource(url, {
        method: "POST",
        headers: headers,
        // signal: abortController,
        body: JSON.stringify(data),
        // openWhenHidden:true,
        onopen(event) {
          if (event.status != 200) {
            Message({
              message: "服务器内部错误",
              type: "error",
              duration: 5 * 1000,
            });
          } else {
            that.loading = true;
          }
        },
        onmessage(event) {
          try {
            var content = event.data;
			console.log(content)
            if (content.indexOf("error_msg") > -1) {
              Message({
                message: content,
                type: "error",
                duration: 5 * 1000,
              });
            } else {
              if(content.indexOf('lastId:') > -1) {
              	that.aid = parseInt(content.replace('lastId:', '').trim());
              	//console.log(that.aid)
              }else {
              	that.content = that.content + content;
              }
              that.rollingBottom();
            }
          } catch (error) {
            console.log(error);
            // that.ctrlAbout.abort()
          }
        },
        onerror(event) {
          // 服务异常
          console.log("onerror:", event);
          that.loading = false;
        },
        onclose(event) {
          console.log("onclose:", event);
          that.loading = false;
          that.$emit("articleGetHistory");
        },
      });
    },
  },
};
</script>

<style lang="less">
.copywritingm {
  background-color: #f4f5f7;
  min-height: 100vh;
  .resultbox {
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    .header {
      background-color: #f4f5f7;
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      display: flex;
      align-items: center;
      height: 60px;
      img {
        height: 18px;
        padding: 0 20px;
      }
      p {
        flex: 1 0 10%;
        text-align: center;
        font-weight: 700;
        margin-left: -40px;
        span {
          display: block;
          width: 223px;
          height: 40px;
          line-height: 40px;
          margin: 0 auto;
          background: linear-gradient(
              106.92deg,
              #10c5fe 14.83%,
              #1093fe 31.52%,
              #4f4fe7 65.11%,
              #b60cb9 91.29%,
              #e0caf5 102.83%
            ),
            #2d8af5;
          box-shadow: 0 2px 8px rgba(52, 70, 237, 0.1);
          border-radius: 55px;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    ul {
      padding: 16px 20px 0;
      background: #fbfcfd;
      li {
        margin-bottom: 20px;
      }
      .listbox {
        max-height: 100%;
        padding: 16px 12px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        font-size: 14px;
        color: #333;
        cursor: pointer;
        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          .status {
            padding: 4px 8px;
            background: #e7f9f4;
            color: #38b865;
            border-radius: 4px;
            font-size: 12px;
            text-align: center;
          }
        }
        .contenbox {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 120px;
          padding: 12px;
          background: #f8f9f9;
          border-radius: 8px;
          font-size: 14px;
          color: #333;
          margin-bottom: 12px;
          cursor: pointer;
          .content {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            color: #000;
          }
          .button {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            margin-top: 12px;
            p {
              padding: 5px 22px;
              text-align: center;
              background: #ffffff;
              border-radius: 32px;
              cursor: pointer;
            }
          }
        }
      }
      .createtime {
        font-size: 10px;
        color: #999;
        margin-top: 8px;
      }
    }
  }
  .copywritingmbox {
    .header {
      display: flex;
      align-items: center;
      height: 60px;
      img {
        height: 18px;
        padding: 0 20px;
      }
      p {
        flex: 1 0 10%;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        padding-left: 20px;
      }
      span {
        width: 82px;
        height: 26px;
        background-image: url(data:image/png;base64,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);
        font-size: 12px;
        color: #2f417b;
        line-height: 26px;
        text-align: center;
      }
    }
    .list {
      position: fixed;
      top: 60px;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.533);
      z-index: 1;
      .listbox {
        background-color: #fff;
        border-radius: 0 0 14px 14px;
        .el-scrollbar {
          height: 360px;
          .el-scrollbar__wrap {
            overflow-x: hidden;
          }
        }
        .swiper {
          height: 42px;
          padding: 0 8px;
          .swiper-container {
            height: 100%;
            .swiper-wrapper {
              height: 100%;
              .swiper-slide {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .swiperOn {
                color: #2d8af5;
              }
            }
          }
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          padding: 20px 0;
          li {
            flex: 0 0 23%;
            text-align: center;
            font-size: 12px;
            .icon {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 6px;
              width: 32px;
              height: 32px;
              background: #fff;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
              border-radius: 8px;
              margin: 0 auto 4px;
              img {
                width: 100%;
              }
            }
          }
          .on {
            color: #2d8af5;
          }
        }
      }
    }
    .formbox {
      margin: 0 20px;
      padding: 20px;
      background-color: #fff;
      border-radius: 20px;
      .el-scrollbar {
        height: calc(100vh - 320px);
        .el-scrollbar__wrap {
          overflow-x: hidden;
        }
      }
    }
    .form {
      padding-bottom: 20px;
      p {
        color: #333;
        font-size: 14px;
        font-weight: 700px;
        margin-bottom: 8px;
      }
      .this {
        padding-left: 12px;
        position: relative;
      }
      .this::after {
        content: "*";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        color: #ff5556;
      }
      .el-input {
        background-color: #f4f5f7;
        border: 1px solid #f4f5f7;
        border-radius: 8px;
        input {
          border: none;
          background: transparent;
        }
        .el-input__count-inner {
          background-color: transparent;
        }
      }
      .el-textarea {
        background-color: #f4f5f7;
        border: 1px solid #f4f5f7;
        border-radius: 8px;
        .el-textarea__inner {
          border: none;
          background: transparent;
          height: 100%;
        }
        .el-input__count {
          background-color: transparent;
        }
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        li {
          height: 36px;
          background: #f7f7f7;
          border-radius: 8px;
          color: #020713;
          border: 1px solid transparent;
          // padding: 10px 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          padding: 0 16px;
          cursor: pointer;
        }
        .on {
          color: rgb(45, 138, 245);
        }
      }
    }
    .tip {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      background: rgba(255, 255, 255, 0.51);
      border-radius: 19px;
      color: #020713;
      font-size: 12px;
      font-weight: 700;
      width: 200px;
      margin: 12px auto;
    }
    .create-btn-cell {
      background-color: #fff;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        width: 223px;
        height: 50px;
        background: linear-gradient(
            106.92deg,
            #10c5fe 14.83%,
            #1093fe 31.52%,
            #4f4fe7 65.11%,
            #b60cb9 91.29%,
            #e0caf5 102.83%
          ),
          #2d8af5;
        box-shadow: 0 2px 8px rgba(52, 70, 237, 0.1);
        border-radius: 55px;
        color: #fff;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .resultbox {
    .header-wrap {
      text-align: center;
      padding-top: 20px;
      i {
        color: #38b865;
      }
      .title {
        font-size: 22px;
        font-weight: 700;
        margin-bottom: 10px;
      }
      .text-gray {
        color: #999;
        font-size: 14px;
      }
    }
    .videobox {
      width: 100%;
      max-height: 300px;
      overflow-y: scroll;
      overflow-x: hidden;
      border-radius: 8px;
      // background-color: #f4f5f7;
      // margin: 20px 32px 0;
      box-sizing: border-box;
      video {
        width: 100%;
        display: block;
      }
      .contentbox {
        width: 100%;
        height: 100%;
        padding: 20px;
        // background: white;
      }
    }

    .btn-wrap {
      padding: 32px 0 16px;
      .share-btn-wrap {
        display: flex;
        justify-content: center;
        .btn-share {
          display: inline-flex;
          width: 185px;
          height: 50px;
          font-size: 18px;
          border-radius: 8px;
          background: #f4f5f7;
          vertical-align: bottom;
          cursor: pointer;
          position: relative;
          justify-content: center;
          align-items: center;
        }
        .btn-down {
          width: 185px;
          height: 50px;
          border-radius: 8px;
          font-size: 18px;
          font-weight: 700;
          background-image: linear-gradient(
            106.92deg,
            rgb(16, 197, 254) 14.83%,
            rgb(16, 147, 254) 31.52%,
            rgb(79, 79, 231) 65.11%,
            rgb(182, 12, 185) 91.29%,
            rgb(224, 202, 245) 102.83%
          );
          color: #fff;
          justify-content: center;
          align-items: center;
          display: inline-flex;
          margin-left: 32px;
        }
      }
      .tips {
        margin-top: 8px;
        color: #999;
        font-size: 12px;
        text-align: center;
      }
    }
  }
  .loading {
    width: 140px;
    display: inline-table;
    .content1 {
      width: 140px;
      // padding: 18rpx;
      max-width: 500rpx;
      border-radius: 30rpx;
      font-size: 28rpx;

      .text {
        color: #c0c4cc;
        margin: 10rpx 0rpx 0rpx 30rpx;
      }

      .dot {
        width: 4px;
        height: 4px;
        background-color: #106eff;
        display: inline-block;
        border-radius: 4px;
        margin: 0 10px;
        animation-name: loading-beat;
        /* 动画完成一个周期所需要的时间 */
        animation-duration: 3s;
        /* 定义动画从何时开始（延迟） */
        animation-delay: 0s;
        /* 动画播放次数（无限） */
        animation-iteration-count: infinite;
      }

      .dot:nth-child(2) {
        animation-delay: 0.2s;
      }

      .dot:nth-child(3) {
        animation-delay: 0.4s;
      }

      .dot:nth-child(4) {
        animation-delay: 0.6s;
      }

      .dot:nth-child(5) {
        animation-delay: 0.8s;
      }

      // .dot:nth-child(6){
      //     animation-delay: .10s;
      // 	animation-name: loading-beat-last;
      // }

      @keyframes loading-beat {
        0% {
          transform: translateY(0) scale(1);
        }

        25% {
          transform: translateY(-8px) scale(1.5);
        }

        50%,
        75%,
        100% {
          transform: translateY(0px) scale(1);
        }
      }

      @keyframes loading-beat-last {
        0% {
          transform: translateY(0) scale(1);
        }

        25%,
        50% {
          transform: translateY(-8px) scale(1.5);
        }

        60% {
          transform: translateY(0px) scale(1);
        }
      }
    }
  }
}
.mode{
	margin-left: 20px;
	margin-right: 20px;
	.imgbox{
		position: relative;
		img{
			width: 100%;
			border-radius: 12px;
		}
		p{
			position: absolute;
			bottom: 12px;
			left: 50%;
			transform: translate(-50%);
			padding: 10px 24px;
			border-radius: 22px;
			background-color: rgba(0,0,0,.5);
			backdrop-filter: blur(2px);
			color: #fff;
			font-size: 14px;
		}
	}
	.tip{
		font-size: 11px;
		color: #999;
		white-space: pre-wrap;
		text-align: center;
		font-size: 12px;
		span{
			color: #2d8af5;
		}
	}
}
.content-wrap{
	padding: 0 20px;
	.el-menu-demo{
		display: flex;
	}
	.el-menu-item{
		height: 40px;
		line-height: 40px;
		// width: 70px;
		padding: 0;
		margin-right: 16px;
	}
}
.content-box{
	height: 420px;
	display: flex;
	.content-divider{
		width: 1px;
		margin: 16px;
		background: #e6e9ed;
	}
	.tags-box{
		text-align: center;
		padding: 5px 12px;
		border-radius: 6px;
		background: #fff;
		flex-shrink: 0;
		cursor: pointer;
		position: relative;
		font-size: 14px;
		color: #333;
	}
	.this{
		background: #f4f5f7;
	}
	.right2{
		flex:1 0 10%;
		// padding: 20px 0;
		img{
			width: 100%;
			border-radius: 8px;
		}
		li{
			width: 98%;
			height: 48px;
			border: 1px solid #f4f5f7;
			background-color: #f4f5f7;
			border-radius: 8px;
			margin: 5px 0;
			padding: 0 8px;
			cursor: pointer;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-betweenc;
			font-size: 14px;
			color: #333;
			img{
				width: 28px;
				margin: 0 8px;
			}
			div:nth-child(3){
				flex: 1 0 10%;
			}
			div:nth-child(2){
				margin-right: 12px;
				padding-right: 12px;
				position: relative;
				border-right: 1px solid #ddd;
			}
		}
		.on{
			border: 1px solid #2d8af5;
			background-color: #2d8af5;
			color: #fff;
		}
	}
	.right{
		flex:1 0 10%;
		padding: 20px 0;
		ul{
			display: flex;
			gap: 12px;
			flex-wrap: wrap;
			li{
				flex: 0 0 46%;
				position: relative;
				overflow: hidden;
			}
			.just-asd{
				justify-content: center;
			}
			.show_image{
				width: 100%;
				border-radius: 8px;
				display: block;
			}
			.title{
				position: absolute;
				bottom: 0;
				width: 100%;
				padding: 10px;
				color: #fff;
				background: linear-gradient(0deg,rgba(0,0,0,.6),transparent);
				font-size: 14px;
			}
			.star{
				display: flex;
				position: absolute;
				top: 0;
				right: 0;
				width: 28px;
				height: 28px;
				font-size: 16px;
				border-radius: 4px;
				background: rgba(0,0,0,.7);
				color: #fff;
				align-items: center;
				justify-content: center;
				// display: none;
			}
		}
	}
}
</style>